import {
  Box,
  Button,
  HStack,
  Image,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Text,
  VStack,
} from '@chakra-ui/react'
import * as Yup from 'yup'
import { Form, Formik } from 'formik'
import React, { useState } from 'react'
import DashboardImage from '../../../assets/images/dashboard_solicitudes.png'
import SelectorField from '../../../components/Selector/SelectorField'
import StoreIcon from '../../../components/SvgIcon/icons/StoreIcon'
import { useRegions } from '../../BranchAndCostCenter/NewBranchOffice'
import { useRequestStatusContext } from '../../../utils/hooks/Context/RequestStatusContext'
import { colors } from '../../../utils/theme/styles'
import { useLoadingContext } from '../../../utils/hooks/Context/LoadingContext'
import { REPOSITORY } from '../../../api/repository/Repository'

const initialValue = {
  nombreLocal: '',
  direccionLocal: '',
  region: '',
  comuna: '',
  nombreEncargadoDeLocal: '',
  datoDeContactoDeLocal: '',
  mailDeSolicitante: '',
}

const validateSchema = Yup.object().shape({
  nombreLocal: Yup.string()
    .min(2, 'Too Short!')
    .max(100, 'Too Long!')
    .required('Required'),
  direccionLocal: Yup.string()
    .min(2, 'Too Short!')
    .max(100, 'Too Long!')
    .required('Required'),
  region: Yup.string().required('Required'),
  comuna: Yup.string().required('Required'),
  nombreEncargadoDeLocal: Yup.string()
    .min(2, 'Too Short!')
    .max(100, 'Too Long!')
    .required('Required'),
  datoDeContactoDeLocal: Yup.string()
    .min(2, 'Too Short!')
    .max(100, 'Too Long!')
    .required('Required'),
  mailDeSolicitante: Yup.string().email('Invalid email').required('Required'),
})

export function SolicitudAction() {
  const { handleOpen: handleOpenLoading, handleClose: handleCLoseLoading } =
    useLoadingContext()

  const { handleOpen, handleSetTitle, handleChangeBody, handleClose } =
    useRequestStatusContext()

  const [open, setOpen] = useState(false)

  const handleToggleModal = () => {
    setOpen(!open)
  }

  const handlerSubmit = async (values) => {
    handleOpenLoading()
    await REPOSITORY.wsEmpresa.dashboard
      .EmpresaSolicitudComercio({
        sNombreFantasia: values.nombreLocal,
        sNombreLocal: values.nombreLocal,
        sDireccionLocal: values.direccionLocal,
        sComuna: values.comuna,
        sRegion: values.region,
        sNombreEncargadoLocal: values.nombreEncargadoDeLocal,
        sDatoContactoLocal: values.datoDeContactoDeLocal,
        sEmailSolicitante: values.mailDeSolicitante,
      })
      .then(() => {
        handleSetTitle('La solicitud ha sido enviada.', 200)
        handleChangeBody(
          <Button
            variant="primary"
            onClick={() => {
              handleClose()
              handleToggleModal()
            }}
          >
            Continuar
          </Button>,
        )
        handleOpen()
      })
      .catch((error) => {
        handleSetTitle(
          '¡Ups! parece que algo salió mal 😕',
          error?.response?.status || 500,
        )
        handleChangeBody(
          <Text textAlign="center">Inténtalo nuevamente en unos minutos.</Text>,
        )
        handleOpen()
      })
      .finally(() => {
        handleCLoseLoading()
      })
  }

  const { regions, foundedCommunes } = useRegions()

  return (
    <>
      <Button
        onClick={handleToggleModal}
        style={{
          margin: 0,
          paddingTop: 25,
          paddingBottom: 25,
          width: 'fit-content',
          borderColor: '#40A4E0',
          backgroundColor: '#40A4E0',
          boxShadow: '3px 4px 9px 0px #00000026',
        }}
      >
        <HStack>
          <StoreIcon width="30" height="30" color="#ffffff" />
          <Text style={{ color: '#FFFFFF', textAlign: 'start' }} fontSize={14}>
            Solicitud de
            <br />
            comercio
          </Text>
        </HStack>
      </Button>

      <Modal isOpen={open} onClose={handleToggleModal} isCentered>
        <ModalOverlay />
        <ModalContent backgroundColor="#f5f5f5" borderRadius={14}>
          <Formik
            initialValues={initialValue}
            onSubmit={handlerSubmit}
            validationSchema={validateSchema}
            validateOnBlur
            validateOnMount
          >
            {({
              values,
              handleBlur,
              handleChange,
              handleSubmit,
              errors,
              touched,
            }) => (
              <Form>
                <ModalBody p="20px 20px 20px 20px">
                  <VStack alignItems="flex-start" mb={10}>
                    <Image
                      width={91.23}
                      src={DashboardImage}
                      alt="Imagen referidos"
                    />
                    <Text variant="h5">Formulario Solicitud de comercio</Text>
                    <Text variant="body1">
                      Completa la información del comercio que te gustaría sumar
                      a la red.
                    </Text>
                  </VStack>
                  <VStack alignItems="flex-start" gap={3}>
                    <Box w="100%">
                      <Text variant="overline" mb={2}>
                        Nombre local*
                      </Text>
                      <Input
                        w="100%"
                        backgroundColor="#fff"
                        placeholder="Nombre local"
                        style={{
                          border: '1px solid #E3E8EE',
                          boxShadow: '0px 1px 2px 0px #37415114',
                        }}
                        id="nombreLocal"
                        name="nombreLocal"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.nombreLocal}
                      />
                      {errors.nombreLocal && touched.nombreLocal ? (
                        <Box>
                          <Text color={colors.log.error} variant="body3">
                            {errors.nombreLocal}
                          </Text>
                        </Box>
                      ) : null}
                    </Box>
                    <Box w="100%">
                      <Text variant="overline" mb={2}>
                        Dirección de local*
                      </Text>
                      <Input
                        w="100%"
                        backgroundColor="#fff"
                        placeholder="Escribe la dirección"
                        style={{
                          border: '1px solid #E3E8EE',
                          boxShadow: '0px 1px 2px 0px #37415114',
                        }}
                        id="direccionLocal"
                        name="direccionLocal"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.direccionLocal}
                      />
                      {errors.direccionLocal && touched.direccionLocal ? (
                        <Box>
                          <Text color={colors.log.error} variant="body3">
                            {errors.direccionLocal}
                          </Text>
                        </Box>
                      ) : null}
                    </Box>
                    <Box w="100%">
                      <Text variant="overline" mb={2}>
                        Región*
                      </Text>
                      <SelectorField
                        isClearable
                        id="region"
                        name="region"
                        value={values.region}
                        options={regions || []}
                        onChange={handleChange}
                        placeholder="Seleccionar"
                        boxShadow="0px 1px 2px 0px #37415114"
                        border="1px solid #E3E8EE"
                      />
                      {errors.region && touched.region ? (
                        <Box>
                          <Text color={colors.log.error} variant="body3">
                            {errors.region}
                          </Text>
                        </Box>
                      ) : null}
                    </Box>
                    <Box w="100%">
                      <Text variant="overline" mb={2}>
                        Comuna*
                      </Text>
                      <SelectorField
                        isClearable
                        id="comuna"
                        name="comuna"
                        value={values.comuna}
                        onChange={handleChange}
                        placeholder="Seleccionar"
                        options={foundedCommunes(values.region)}
                        boxShadow="0px 1px 2px 0px #37415114"
                        border="1px solid #E3E8EE"
                      />
                      {errors.comuna && touched.comuna ? (
                        <Box>
                          <Text color={colors.log.error} variant="body3">
                            {errors.comuna}
                          </Text>
                        </Box>
                      ) : null}
                    </Box>
                    <Box w="100%">
                      <Text variant="overline" mb={2}>
                        Nombre de encargado de local
                      </Text>
                      <Input
                        w="100%"
                        backgroundColor="#fff"
                        placeholder="Nombre completo"
                        style={{
                          border: '1px solid #E3E8EE',
                          boxShadow: '0px 1px 2px 0px #37415114',
                        }}
                        id="nombreEncargadoDeLocal"
                        name="nombreEncargadoDeLocal"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.nombreEncargadoDeLocal}
                      />
                      {errors.nombreEncargadoDeLocal &&
                      touched.nombreEncargadoDeLocal ? (
                        <Box>
                          <Text color={colors.log.error} variant="body3">
                            {errors.nombreEncargadoDeLocal}
                          </Text>
                        </Box>
                      ) : null}
                    </Box>
                    <Box w="100%">
                      <Text variant="overline" mb={2}>
                        Teléfono de contacto
                      </Text>
                      <Input
                        w="100%"
                        backgroundColor="#fff"
                        placeholder="Número Teléfono"
                        style={{
                          border: '1px solid #E3E8EE',
                          boxShadow: '0px 1px 2px 0px #37415114',
                        }}
                        id="datoDeContactoDeLocal"
                        name="datoDeContactoDeLocal"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.datoDeContactoDeLocal}
                      />
                      {errors.datoDeContactoDeLocal &&
                      touched.datoDeContactoDeLocal ? (
                        <Box>
                          <Text color={colors.log.error} variant="body3">
                            {errors.datoDeContactoDeLocal}
                          </Text>
                        </Box>
                      ) : null}
                    </Box>
                    <Box w="100%">
                      <Text variant="overline" mb={2}>
                        mail de solicitante
                      </Text>
                      <Input
                        w="100%"
                        backgroundColor="#fff"
                        placeholder="mail@correo.com"
                        style={{
                          border: '1px solid #E3E8EE',
                          boxShadow: '0px 1px 2px 0px #37415114',
                        }}
                        id="mailDeSolicitante"
                        name="mailDeSolicitante"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.mailDeSolicitante}
                      />
                      {errors.mailDeSolicitante && touched.mailDeSolicitante ? (
                        <Box>
                          <Text color={colors.log.error} variant="body3">
                            {errors.mailDeSolicitante}
                          </Text>
                        </Box>
                      ) : null}
                    </Box>
                  </VStack>
                  <Button mt={7} borderRadius={5} onClick={handleSubmit}>
                    Enviar
                  </Button>
                </ModalBody>
              </Form>
            )}
          </Formik>
        </ModalContent>
      </Modal>
    </>
  )
}
